export const NOTIF_FAIL: string = "error";
export const NOTIF_INFO: string = "info";
export const NOTIF_DEFAULT: string = "default";
export const NOTIF_SUCCESS: string = "success";
export const NOTIF_WARN: string = "warning";

// Property keys.
export const PROPBODYCONTENT: string = "BODYCONTENT";
export const PROPBODYTYPE: string = "BODYTYPE";
export const PROPSUBJECT: string = "SUBJECT";
export const PROPFROMEMAIL: string = "FROMEMAIL";
export const PROPTOEMAIL: string = "TOEMAIL";
export const PROPCCEMAIL: string = "CCEMAIL";
export const PROPBCCEMAIL: string = "BCCEMAIL";
export const PROPJWTTOKEN: string = "CLIENTTOKEN";

export const PROPCALLBACKTOKEN: string = "CALLBACKTOKEN";
export const PROPMAILID: string = "MAILID";
export const PROPBACKUPID: string = "BACKUPID";
export const PROPEMAILUNIQUEID: string = "EMAILUNIQUEID";
export const PROPLOCKTEMPLATE: string = "LOCKTEMPLATE";
export const PROPMESSAGETEMPLATE: string = "MESSAGETEMPLATE";

export const PROPSEGSUBMIT: string = "PROPSEGSUBMIT";
export const PROPSEGRETURN: string = "PROPSEGRETURN";

export const PROPTRACE: string = "TRACE";
export const PROPERRORTRACE: string = "ERRORTRACE";

export const EXPERIENCED_USER_MIN_EMAILS: number = 5;
export const tooltipCounter: number = 6;
export const GSubjectADD: string = " - [Secured2 Contents]";
export const stndseperatorstart: string = "[";
export const stndseperatorend: string = "]<br>";

export const STND_ERR_MESSAGE: string = "Secured2 Issue <ACTION>, please try again <MSG>";
export const STND_ERR_SYSMESSAGE: string = "Error occured in <FUNC>, Issue <MSG>, please try again <ERROR>";

export const STND_SUC_MESSAGE: string = "Secured2 <ACTION>, completed Sucecssfully <MSG>";
export const defaultContent: string =
  '<html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><style type="text/css" style="display:none;"><!-- P {margin-top:0;margin-bottom:0;} --></style></head><body dir="ltr"><div id="divtagdefaultwrapper" style="font-size:12pt;color:#000000;background-color:#FFFFFF;font-family:Calibri,Arial,Helvetica,sans-serif;"><p><br></p></div></body></html>';

// Static TEXT.
export var GPROCESS: string = "0";

// Define an interface for the expected JSON response (matches Java UploadVO)

/*export interface UploadVO {
  // Add properties based on what UploadVO contains in Java
  // Example:
  success: boolean;
  message?: string;
  fileId?: string;
  // ... other fields returned by the backend
}*/

// --- Interfaces ---
type UploadStatus = "pending" | "uploading" | "completed" | "failed" | "cancelled" | "queued";

export interface FileUploadState {
  id: string; // Unique ID for this upload instance
  file: File;
  status: UploadStatus;
  progress: number; // Overall progress (0-100)
  totalChunks?: number; // Only relevant for chunking
  uploadedChunks?: number; // Only relevant for chunking
  errorMessage?: string;
  isChunked: boolean; // Indicate if chunking is used for this file
}

// make call to sercured2 services
export interface UploadVO {
  status: string;
  baseDirectory: string;
  resultIdentifier: string;
  result: number;
  trace: string;
}

// Define the structure for the data needed by the function
export interface ChunkUploadData {
  backupid: string;
  msid: string;
  dzUuid: string;
  dzChunkIndex: string; // Or number, depending on how you handle it
  dzTotalFileSize: string; // Or number
  dzCurrentChunkSize: string; // Or number
  dzTotalChunkCount: string; // Or number
  dzChunkByteOffset: string; // Or number
  dzChunkSize: string; // Or number
  dzFilename: string;
  fileChunk: Blob | File; // The actual binary data for the chunk
}

// make call to sercured2 services
export interface OutlookSecurityVO {
  resultIdentifier: string;
  backupid: string;
  result: number;
  subscriptionVO: SubscriptionVO;
  trace: string;
}

export interface SubscriptionVO {
  resultIdentifier: string;
  result: number;
  trace: string;
  subscription: Subscription;
  serviceName: string;
  valid: boolean;
  checkTrial: boolean;
  clientToken: string;
}

export interface Subscription {
  createdDate: number;
  paidDate: number;
  startDate: number;
  endDate: number;
  individual: boolean;
  emailCounter: number;
  remainingFreeTrial: number;
  type: string;
  active: boolean;
  totalTrial: number;
}

// template interfaces
export interface TemplateVO {
  items: items;
  lockTemplate: string;
  resultIdentifier: string;
  result: number;
  trace: string;
}

export interface items {
  items: TemplateItem;
}

export interface OutlookVO {
  subscriptionVO: SubscriptionVO;
  result: number;
  trace: string;
  resultIdentifier: string;
}

export interface TemplateItem {
  id: number; // Integer in Java corresponds to number in TypeScript
  name: string; // String in Java corresponds to string in TypeScript
  template: string;
  templateConfig: string;
  version: string;
  date: number; // Long in Java corresponds to number in TypeScript (for large integers)
  subcomponents: Record<string, string>; // HashMap<String, String> in Java corresponds to Record<string, string> in TypeScript
}
